<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      markId: null,
      markBox: [],
    };
  },
  computed: {
    ...mapState(['userInfo','authToken'])
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
    this.$api.domainPage().then((res) => {
      this.markBox = res.data.data;
    });
    this.markId = this.userInfo.domainId;
  },
  methods: {
    changeMark(row,index){
      this.markId = row.id;
    },
    onSub(){
      if(this.$glf.isEmpty(this.markId)){
        this.$toast('请选择所属领域');
        return false;
      }
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.$api.loginUserEdit({domainId: this.markId}).then(res=>{
        this.$store.dispatch('refreshUser');
        this.$toast('保存成功');
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/follow/index.vue